import { connectedStore } from '../../store';
import actions from '../actions';

const createPageFromTemplate = (
  pageTemplateId,
  title,
  displayInNavigation = false,
  pageModifier = null,
  displayBusinessName = null,
  skipActivePageChange = false
) =>
  new Promise((resolve, reject) => {
    const store = connectedStore.get();
    store.dispatch(
      actions.createPageFromTemplate(
        pageTemplateId,
        title,
        displayInNavigation,
        pageModifier,
        displayBusinessName,
        skipActivePageChange,
        resolve,
        reject
      )
    );
  });

export default createPageFromTemplate;
